module.exports = __webpack_public_path__ + "img/13.941ee118.png";